import React from 'react';
import Typography from '@mui/material/Typography';
import { useFormContext, useFieldArray, useWatch } from 'react-hook-form';
import Document from '#component/shipment/form/documents/document';
import FileUpload from '#component/shipment/form/documents/file-upload';
import { submitAndGoBack } from '#component/shipment/form/use-step-submit';
import {
  StyledPaper,
  ButtonCnt,
  StyledButton
} from './styles';

const Documents = props => {
  const {
    fields,
    values = [],
    append,
    remove,
    error,
    disabled
  } = props;

  const handleUpload = files => {
    files.forEach(file => {
      append(file);
    });
  };

  return (
    <>
      {fields?.map((field, index) => (
        <Document
          key={field.id || index}
          file={values[index] ?? field}
          index={index}
          member={`files[${index}]`}
          remove={remove}
          disabled={disabled}
        />
      ))}
      {error && <Typography align="center" color="error">{error}</Typography>}
      <FileUpload
        disabled={fields.length >= 10 || disabled}
        uploadedLength={fields.length}
        handleUpload={handleUpload}
      />
    </>
  );
};

/**
 * Renders form with Documents, save and cancel buttons.
 * @returns {React.FC}
 */

const Form = props => {
  const methods = useFormContext();
  const { control, handleSubmit, formState } = methods || {};
  const { fields, append, remove } = useFieldArray({ control, name: 'files' });
  const filesErrors = formState?.errors?.files;
  const groupError = filesErrors?.root?.message ?? filesErrors?.message;
  // `fields` carry RHF's own key as `id`, the real file ids live in the form values
  const filesValues = useWatch({ control, name: 'files' });

  const {
    submitting,
    editable,
    dispatch,
    SaveButton = () => null,
    CancelButton = () => null,
    onFormSubmit
  } = props;

  const handleBackClick = () => submitAndGoBack(dispatch, methods, onFormSubmit);

  return (
    <form autoComplete="off" onSubmit={handleSubmit?.(onFormSubmit)}>
      <StyledPaper elevation={0}>
        <Documents
          fields={fields}
          values={filesValues}
          append={append}
          remove={remove}
          error={groupError}
          disabled={!editable}
        />
      </StyledPaper>
      <ButtonCnt>
        <StyledButton as={CancelButton} />
        <StyledButton
          disabled={submitting}
          type="button"
          variant="outlined"
          onClick={handleBackClick}
        >
          Back
        </StyledButton>
        {editable && (
          <StyledButton as={SaveButton} disabled={submitting} />
        )}
      </ButtonCnt>
    </form>
  );
};

export default Form;
